import isNativeMobile from '@/utils/platform/isNativeMobile';

/**
 * Standalone = the miniapp-shell / direct-browser surface: we own the top
 * window AND we're not inside the native Picsart app. A native WebView is
 * also the top window (`window.parent === window`), but there the host
 * delivers deeplinks/location via the SDK model, not the browser URL — so
 * native must NOT be classified as standalone.
 */
export const isStandalone = () =>
  typeof window !== 'undefined' &&
  window.parent === window &&
  !isNativeMobile();
